// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentIsValidMemberNumberRequestModel {
    static getAttributeTypeMap() {
        return EnrollmentIsValidMemberNumberRequestModel.attributeTypeMap;
    }
}
EnrollmentIsValidMemberNumberRequestModel.discriminator = undefined;
EnrollmentIsValidMemberNumberRequestModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "haveACard",
        "baseName": "haveACard",
        "type": "boolean"
    },
    {
        "name": "partyId",
        "baseName": "partyId",
        "type": "number"
    },
    {
        "name": "checkForEnrollment",
        "baseName": "checkForEnrollment",
        "type": "boolean"
    }
];
//# sourceMappingURL=enrollmentIsValidMemberNumberRequestModel.js.map